import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const SiteMediaContext = createContext({ media: {}, refresh: () => {} });

// Real Kensmarc photos assigned to fixed site slots by the admin.
export function SiteMediaProvider({ children }) {
  const [media, setMedia] = useState({});
  const refresh = useCallback(() => {
    api.get("/site-media").then((r) => setMedia(r.data || {})).catch(() => {});
  }, []);
  useEffect(refresh, [refresh]);
  return <SiteMediaContext.Provider value={{ media, refresh }}>{children}</SiteMediaContext.Provider>;
}

export const useSiteMedia = () => useContext(SiteMediaContext);
